export const naceDTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.test.nace_d.inicio_teste' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.test.nace_d.final_teste' },
  { header: 'generateReport.dataToResult.report.general.project' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.test.nace_d.id_numeric' },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.test.nace_d.aco' },
  { header: 'generateReport.dataToResult.report.test.nace_d.bitola' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ippn' },
  { header: 'generateReport.dataToResult.report.test.nace_d.lote_tt' },
  { header: 'generateReport.dataToResult.report.test.nace_d.posicao_amostra' },
  {
    header: 'generateReport.dataToResult.report.test.nace_d.ordem_de_processo',
  },
  { header: 'generateReport.dataToResult.report.test.nace_d.tipo_entalhe' },
  { header: 'generateReport.dataToResult.report.test.nace_d.pre_trinca' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ac_min_mpa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ac_min_in' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ac_med_mpa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ac_med_in' },
  { header: 'generateReport.dataToResult.report.test.nace_d.res_min_mpa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.res_min_in' },
  { header: 'generateReport.dataToResult.report.test.nace_d.res_min_med_mpa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.res_min_med_in' },
  { header: 'generateReport.dataToResult.report.test.nace_d.solucao' },
  { header: 'generateReport.dataToResult.report.test.nace_d.gas_de_teste' },
  { header: 'generateReport.dataToResult.report.test.nace_d.temperatura' },
  { header: 'generateReport.dataToResult.report.test.nace_d.lote_solucao' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ph_da_solucao' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ph_dps_saturacao' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ph_fim_teste' },
  { header: 'generateReport.dataToResult.report.test.nace_d.h2s_inicial' },
  { header: 'generateReport.dataToResult.report.test.nace_d.h2s_meio' },
  { header: 'generateReport.dataToResult.report.test.nace_d.h2s_final' },
  { header: 'generateReport.dataToResult.report.test.nace_d.w2h_min' },
  { header: 'generateReport.dataToResult.report.test.nace_d.w2h_max' },
  { header: 'generateReport.dataToResult.report.test.nace_d.slots_min' },
  { header: 'generateReport.dataToResult.report.test.nace_d.slots_max' },
  { header: 'generateReport.dataToResult.report.test.nace_d.braco_min' },
  { header: 'generateReport.dataToResult.report.test.nace_d.braco_max' },
  { header: 'generateReport.dataToResult.report.test.nace_d.n_min' },
  { header: 'generateReport.dataToResult.report.test.nace_d.n_max' },
  { header: 'generateReport.dataToResult.report.test.nace_d.specimen' },
  { header: 'generateReport.dataToResult.report.test.nace_d.tipo_cp' },
  { header: 'generateReport.dataToResult.report.test.nace_d.w_2h' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dist_inicial' },
  { header: 'generateReport.dataToResult.report.test.nace_d.b' },
  { header: 'generateReport.dataToResult.report.test.nace_d.bn' },
  { header: 'generateReport.dataToResult.report.test.nace_d.slot_s' },
  { header: 'generateReport.dataToResult.report.test.nace_d.wedge_t' },
  { header: 'generateReport.dataToResult.report.test.nace_d.t_s' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dist_final' },
  { header: 'generateReport.dataToResult.report.test.nace_d.abert_braco' },
  { header: 'generateReport.dataToResult.report.test.nace_d.n' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dq1_1' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dq1_2' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dq1_3' },
  { header: 'generateReport.dataToResult.report.test.nace_d.dq1_media' },
  { header: 'generateReport.dataToResult.report.test.nace_d.p' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_aa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_bb' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_cc' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_dd' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_ee' },
  { header: 'generateReport.dataToResult.report.test.nace_d.comp_med' },
  { header: 'generateReport.dataToResult.report.test.nace_d.ana_fratura' },
  { header: 'generateReport.dataToResult.report.test.nace_d.criteiro' },
  { header: 'generateReport.dataToResult.report.test.nace_d.kissc_mpa' },
  { header: 'generateReport.dataToResult.report.test.nace_d.kissc_in' },
  { header: 'generateReport.dataToResult.report.test.nace_d.result1' },
  { header: 'generateReport.dataToResult.report.test.nace_d.result2' },
  { header: 'generateReport.dataToResult.report.test.nace_d.observacao' },
]
